import { forwardRef } from 'react'
import { IconProps } from '../Types'
import { filterDOMProps } from '@react-aria/utils'

export const WordPressBrand = forwardRef<SVGSVGElement, IconProps>(({ size = 35, color, ...rest }, forwardedRef) => {
  const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      ref={forwardedRef}
      {...domProps}
    >
      <path
        d="M0.124939 15.9457C0.124939 22.0761 3.6877 27.374 8.85399 29.8846L1.46588 9.64258C0.606497 11.5688 0.124939 13.7004 0.124939 15.9457Z"
        fill="#2B2F38"
      />
      <path
        d="M26.069 15.1637C26.069 13.2496 25.3814 11.9241 24.7917 10.8923C24.0066 9.61653 23.2707 8.53614 23.2707 7.26037C23.2707 5.83665 24.3505 4.51137 25.8715 4.51137C25.9402 4.51137 26.0053 4.51991 26.0722 4.52374C23.3167 1.99931 19.6454 0.458008 15.6132 0.458008C10.2023 0.458008 5.44183 3.23412 2.67242 7.43896C3.0358 7.44986 3.37826 7.45752 3.66914 7.45752C5.28917 7.45752 7.79687 7.26096 7.79687 7.26096C8.63178 7.21174 8.73022 8.438 7.89618 8.53673C7.89618 8.53673 7.05714 8.63546 6.12349 8.68438L11.7637 25.4604L15.1532 15.2952L12.7401 8.68379C11.906 8.63487 11.1159 8.53614 11.1159 8.53614C10.2813 8.48722 10.3791 7.21115 11.2137 7.26037C11.2137 7.26037 13.7715 7.45693 15.2934 7.45693C16.9132 7.45693 19.4212 7.26037 19.4212 7.26037C20.2567 7.21115 20.3548 8.43741 19.5205 8.53614C19.5205 8.53614 18.6797 8.63487 17.7478 8.68379L23.345 25.3328L24.8898 20.1705C25.5594 18.0283 26.069 16.4896 26.069 15.1637Z"
        fill="#2B2F38"
      />
      <path
        d="M15.8849 17.2998L11.2379 30.8029C12.6254 31.2107 14.0927 31.4338 15.6131 31.4338C17.4168 31.4338 19.1464 31.122 20.7564 30.5559C20.7149 30.4896 20.6772 30.4191 20.6462 30.3425L15.8849 17.2998Z"
        fill="#2B2F38"
      />
      <path
        d="M29.2033 8.51465C29.2699 9.00798 29.3077 9.53757 29.3077 10.1072C29.3077 11.6789 29.0141 13.4456 28.13 15.6547L23.399 29.3328C28.0036 26.6478 31.1007 21.6593 31.1007 15.9456C31.101 13.2529 30.4131 10.7208 29.2033 8.51465Z"
        fill="#2B2F38"
      />
    </svg>
  )
})
